import type React from 'react';

import { hasItem } from '@sravni/ugc/lib/specialOffers/helpers';
import { ACTIONS, INSURANCE_OFFERS, VITRINS_OFFERS_LIST } from '@sravni/ugc/lib/specialOffers/lists';
import type { Tab } from '@sravni/ugc/lib/specialOffers/types';

import { Osago } from '../components/ActionsBlocks/Osago';
import { InsuranceOsago } from '../components/InsuranceOsago';
import { OffersBlocks } from '../components/OffersBlocks';

import type { MessageParams } from './sendMessageToParentWindow';

export interface CustomOneTabsComponentProps {
  contentRef: React.RefObject<HTMLDivElement>;
  isMobile: boolean;
  setShowPreloader: { on: () => void; off: () => void; toggle: () => void };
  sendMessageToParentWindow: (params: MessageParams) => void;
  maxDesktopVisibleItems: number;
  isWithLinkToAll: boolean;
}

export const getComponentByTabType = (tab: Tab): React.FunctionComponent<any> | null => {
  if (hasItem(VITRINS_OFFERS_LIST, tab)) {
    return OffersBlocks;
  }

  if (tab.type === ACTIONS.osago) {
    return Osago;
  }

  if (tab.type === INSURANCE_OFFERS.insuranceOsago) {
    return InsuranceOsago;
  }

  return null;
};
